
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/About",
      function () {
        return require("private-next-pages/About.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/About"])
      });
    }
  